import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import passwordService from '../../services/passwordService';
import './LoginPage.css';

export default function ResetPasswordPage() {
  const navigate                    = useNavigate();
  const [searchParams]              = useSearchParams();
  const email                       = searchParams.get('email');
  const token                       = searchParams.get('token');
  const [password,    setPassword]  = useState('');
  const [verPass,     setVerPass]   = useState(false);
  const [mensaje,     setMensaje]   = useState(null);
  const [cargando,    setCargando]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setMensaje(null);
    try {
      const res = await passwordService.resetear(email, token, password);
      setMensaje({ tipo: 'success', texto: res.message });
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMensaje({
        tipo: 'danger',
        texto: err.response?.data?.message || 'Error al restablecer la contraseña.',
      });
    } finally {
      setCargando(false);
    }
  };

  return (
    <main className="login-wrapper">
      <div className="login-card">

        {/* Ícono */}
        <div className="login-icon">
          <FaLock />
        </div>

        <h2 className="login-title">Nueva contraseña</h2>
        <p className="login-subtitle">Ingresa tu nueva contraseña</p>

        {mensaje && (
          <div className={`alert alert-${mensaje.tipo} text-center small mb-3`}>
            {mensaje.texto}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-3">
            <label className="login-label">
              <FaLock className="me-2" />
              Nueva contraseña
            </label>
            <div className="input-password-wrapper">
              <input
                type={verPass ? 'text' : 'password'}
                className="input-custom"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
              <button
                type="button"
                className="btn-ver-pass"
                onClick={() => setVerPass(!verPass)}
              >
                {verPass ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn-primary-custom mb-3"
            disabled={cargando}
          >
            {cargando ? 'Guardando...' : 'Restablecer contraseña'}
          </button>
        </form>

      </div>
    </main>
  );
}